import PcseoHomeHospital from "@jdh-cargo/block-pcseo-home-hospital"
import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { setHospitalTDK } from "utils/hospital";
import BreadCrumb from "../BreadCrumb"
import { parseUrl, Template } from "../template"

export default () => {
  const localParams = useParams<Record<any, any>>();
  const pageParam = useMemo(() => {
    const id = localParams?.id;
    return parseUrl(id, { position: {index: 0, provinceId: 0, cityId: 1}, pageId: 1 });
  }, []);
  console.log(pageParam, 888);
  return (
    <Template>
      <BreadCrumb title="医院列表"></BreadCrumb>
      <PcseoHomeHospital
        moreUrl=""
        pageShow={true}
        tabJump={true} // tab点击跳转路由
        setTDK={(param: any) => {
          console.log(param, 10909909);
          const isAll = !pageParam.cityId && !pageParam.provinceId;
          if (isAll) {
            setHospitalTDK(
              `找医院 - 京东健康互联网医院`,
              `京东健康找医院`,
              `京东健康找医院`,
            );
            return;
          }
          // 省名
          const posName = pageParam.provinceId ? param.provinceName:'';
          // 市名
          const cityName = pageParam.cityId ? param.cityName : ''
          const totalStr = `${posName}${cityName}`;

          setHospitalTDK(
            `${totalStr}查找医院 - 京东健康互联网医院`,
            `京东健康${totalStr}查找医院`,
            `京东健康${totalStr}查找医院`
          )
          
        }}
        {...pageParam}
      />
    </Template>
  )
}